import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  useMutation,
  useQueryClient,
} from "react-query";
import UserService from "../../../../services/user.service";
import { useProfile } from "../../../../queries/hooks";
import { queryKeys } from "../../../../queries/keys";
import { UserProfileDragAndDrop } from "../Users/UserProfileDragAndDrop";
import { toast } from "react-toastify";
import { LabeledInput } from "../../../UI/LabeledInput";
import RoleService from "../../../../services/roles.service";
import ReactInputMask from "react-input-mask";
import LoadingModal from "../../../LoadingModal";
import RolePermissionsService from "../../../../services/rolesPermissions.service";
import { AuthContext } from "../../../../contexts/auth";
import { ReactComponent as UploadPhotoIcon } from "../../../../assets/styled-icons/UploadPhoto.svg";
import { ReactComponent as BlankAvatar } from "../../../../assets/styled-icons/BlankAvatar.svg";
import { IoMdInformationCircleOutline } from "react-icons/io";
import DragAndDrop from "../../../UI/FileDragAndDrop";

const Profile = () => {
  const { actionOptions, user, userRoleName } = useContext(AuthContext);
  const isAdmin = user?.role_id === "USER_ADMINISTRATOR" || userRoleName === "Administrador";
  const [roles, setRoles] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openPhotoMenu, setOpenPhotoMenu] = useState(false);
  const queryClient = useQueryClient();
  const inputRef = useRef<HTMLInputElement>(null);

  const openFileDialog = () => {
    inputRef.current?.click();
  };

  useEffect(() => {
    RolePermissionsService.allRoles().then((res) => {
      setRoles(res);
    });
  }, []);

  const { isLoading, data, error, status } = useProfile();

  const [profileData, setProfileData] = useState({
    _id: "",
    name: "",
    user_name: "",
    email: "",
    role_id: "",
    function_id: "",
    description: "",
    phone: "",
    image_url: "",
    active: false,
  });

  const userRole =
    roles.find((i) => i?._id === profileData.function_id)?.name || "";

  useEffect(() => {
    if (status === "success") {
      setProfileData(data);
    }
  }, [status, data]);

  function typesRender() {
    return roles.map((el: any) => {
      return <MenuItem value={el._id}>{el.name}</MenuItem>;
    });
  }

  const { mutate: updateUser, isLoading: isLoadingUpdate } = useMutation(
    (data: any) => UserService.update(profileData._id, data),
    {
      onSuccess: () => {
        toast.success("Usuário atualizado com sucesso!");
        queryClient.invalidateQueries(queryKeys.profile);
      },
      onError: (error) => {
        toast.error("Não foi possível atualizar o usuário");
      },
    }
  );

  function handleChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    setProfileData({ ...profileData, [e.target.name]: e.target.value });
  }
  const submitHandler = async () => {
    const data = {
      ...profileData,
    };

    const role = await RolePermissionsService.roles({ id: data.function_id });

    if (role.name === "Administrador") {
      data.role_id = "USER_ADMINISTRATOR";
    } else {
      data.role_id = "USER_GUEST";
    }

    updateUser(data);
  };

  const handleSelectFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);

    if (validateFiles(files)) handleUpload(files);
  };

  function validateFiles(files: File[]) {
    if (!files) return false;
    if (files.length > 1) {
      toast.warn(`O limite de arquivos por upload é 1`);
      return false;
    }
    if (
      files.some(
        (file) =>
          !["png", "jpeg", "jpg"].some((format) =>
            file.name.toLowerCase().endsWith(format.toLowerCase())
          )
      )
    ) {
      toast.warn(
        `Formato não permitido, use um listado a seguir: ${[
          "png",
          "jpeg",
          "jpg",
        ].join(",")}`
      );
      return false;
    }
    return true;
  }

  async function handleUpload(files: File[]) {
    let src = URL.createObjectURL(files[0]);
    // create syntetic event
    let reader = new FileReader();

    reader.readAsDataURL(files[0]);

    reader.onload = function () {
      let e = {
        target: {
          name: "image_url",
          value: reader.result,
        },
      } as React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;
      handleChange(e);
    };

    reader.onerror = function () {};
  }
  return (
    <Box
      px={"24px"}
      pt={"24px"}
      pb={"28px"}
      sx={{ flex: 1 }}
      gap={2}
      display={"flex"}
      justifyContent={"space-between"}
    >
      <LoadingModal isLoading={isLoading} />
      <Box
        display={"flex"}
        mb={4}
        alignItems={"flex-start"}
        flex={1}
        width={"100%"}
        flexDirection={"column"}
        gap={2}
      >
        <span style={{ fontSize: 20 }}>Perfil</span>
        <Box
          display={"flex"}
          alignItems={"center"}
          width={"100%"}
          mb={2}
          flexDirection={"row"}
          gap={6}
          mt={2}
        >
          <div>
            <div style={{ width: 150, height: 150 }}>
              {!profileData.image_url ? (
                <>
                  <BlankAvatar width={150} height={150} />
                  <div
                    style={{
                      position: "relative",
                      top: "-30%",
                      right: "-65%",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      setAnchorEl(e.currentTarget);
                      setOpenPhotoMenu(true);
                    }}
                  >
                    <UploadPhotoIcon />
                  </div>
                </>
              ) : (
                <>
                  <img
                    width={150}
                    height={150}
                    src={profileData.image_url}
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                  />
                  <div
                    style={{
                      position: "relative",
                      top: "-30%",
                      right: "-65%",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      setAnchorEl(e.currentTarget);
                      setOpenPhotoMenu(true);
                    }}
                  >
                    <UploadPhotoIcon />
                  </div>
                </>
              )}
            </div>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openPhotoMenu}
              onClose={() => {
                setAnchorEl(null);
                setOpenPhotoMenu(false);
              }}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              autoFocus={false}
            >
              <MenuItem
                autoFocus={false}
                onClick={() => {
                  setAnchorEl(null);
                  setOpenPhotoMenu(false);
                  openFileDialog();
                }}
              >
                Escolher do computador
              </MenuItem>
            </Menu>
            <input
              ref={inputRef}
              type="file"
              style={{ display: "none" }}
              accept={["png", "jpeg", "jpg"].join(",")}
              multiple={false}
              onChange={handleSelectFiles}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <span style={{ fontSize: 20, fontWeight: 500 }}>
              {profileData.name}
            </span>
            <span>{userRole}</span>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 4,
              }}
            >
              <IoMdInformationCircleOutline color="#666666" />
              <span style={{ color: "#666666" }}>
                Utilize uma foto sem fundo ou fundo branco.
              </span>
            </div>
          </div>
          {/* {!profileData.image_url ? (
            <>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                width={"100%"}
                margin={"auto"}
              >
                <strong>Foto de Perfil </strong>{" "}
                <span> usar foto sem fundo ou fundo branco</span>
              </Box>
              <UserProfileDragAndDrop
                count={1}
                formats={["png", "jpeg", "jpg"]}
                onUpload={handleUpload}
                name={"image_url"}
              />
            </>
          ) : (
            <Box display={"flex"} flexDirection={"column"}>
              <img
                src={profileData.image_url}
                alt=""
                width="120px"
                height="120px"
                style={{ borderRadius: "50%" }}
              />
              <p
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setProfileData({ ...profileData, image_url: "" });
                }}
              >
                <span>
                  Upload concluído clique aqui para substituir a imagem
                </span>
              </p>
            </Box>
          )} */}
        </Box>
        <Box
          display={"flex"}
          alignItems={"flex-start"}
          flexDirection={"column"}
          flex={1}
          gap={2}
          width={"100%"}
        >
          <span style={{ fontWeight: "bold" }}>Suas informações</span>
          <Box
            display={"flex"}
            alignItems={"flex-start"}
            gap={2}
            width={"100%"}
          >
            <LabeledInput
              label="Nome completo"
              value={profileData.name}
              name="name"
              onChange={handleChange}
              disabled={!isAdmin}
            />
          </Box>
          <Box
            display={"flex"}
            alignItems={"flex-start"}
            gap={2}
            width={"100%"}
          >
            <LabeledInput
              label="Email"
              value={profileData.email}
              name="email"
              onChange={handleChange}
              disabled={!isAdmin}
            />
            {/* <LabeledInput label="Celular" value={profileData.phone} name="phone" onChange={handleChange} /> */}
            <ReactInputMask
              //@ts-ignore
              maskPlaceholder={null}
              mask="(99) 99999-9999"
              value={profileData.phone}
              onChange={handleChange}
              name="phone"
            >
              <LabeledInput
                fullWidth
                size="small"
                label="Celular"
                name="phone"
                value={profileData.phone}
                onChange={handleChange}
                placeholder="(00) 0 0000 0000"
              />
            </ReactInputMask>
          </Box>
          <div
            style={{
              width: "100%",
              height: 1,
              backgroundColor: "#E0E0E0",
              marginTop: 16,
              marginBottom: 16,
            }}
          />
          <Box
            display={"flex"}
            alignItems={"flex-start"}
            flexDirection={"column"}
            flex={1}
            gap={2}
            width={"100%"}
          >
            <span style={{ fontWeight: "bold" }}>Função e acesso</span>
            <Box
              display={"flex"}
              alignItems={"flex-start"}
              flexDirection={"column"}
              width={"100%"}
            >
              <InputLabel sx={{ fontSize: 13 }}>Função</InputLabel>
              <FormControl style={{ width: "100%" }} size="small">
                <Select
                  style={{ width: "100%" }}
                  value={profileData.function_id}
                  onChange={(e) => {
                    setProfileData({
                      ...profileData,
                      function_id: e.target.value,
                    });
                  }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  size="small"
                  name="function_id"
                  disabled={!isAdmin}
                  sx={{
                    "&.Mui-disabled": {
                      backgroundColor: "rgba(0, 0, 0, 0.06)",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(0, 0, 0, 0.23)",
                      },
                    },
                  }}
                  MenuProps={{
                    style: {
                      maxHeight: 450,
                    },
                  }}
                >
                  {typesRender()}
                </Select>
              </FormControl>
            </Box>
            <LabeledInput
              label="Login"
              value={profileData.user_name}
              name="user_name"
              onChange={handleChange}
              disabled={!isAdmin}
            />
          </Box>
          <Box
            display={"flex"}
            justifyContent={"flex-end"}
            gap={2}
            width={"100%"}
          >
            <Button
              variant="contained"
              onClick={submitHandler}
              style={{ padding: "8px 16px" }}
            >
              Salvar
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Profile;
